import { useGetQuizTeacher } from '@repo/api/quiz/useGetQuizTeacher';

import { useLocalStorage } from '@/hooks/local-storage';

import type { QuizBuilderData } from '.';

const initialQuizData: QuizBuilderData = {
  name: '',
  desc: '',
  time: 0,
  maxAttempts: 0,
  deadline: undefined,
  available: undefined,
  content: [],
  quizId: undefined,
  timestamp: new Date('1000-01-01').toISOString(),
};

export function useQuizBuilderData(quizId?: string) {
  const quizQuery = useGetQuizTeacher(quizId);
  const [quizData, setQuizData, removeQuizDraftData] = useLocalStorage<QuizBuilderData>('quizDraftData', initialQuizData);

  const updateQuizDraftData = (newData: Partial<QuizBuilderData>) => {
    setQuizData((prevData) => ({
      ...prevData,
      ...newData,
      timestamp: new Date().toISOString(),
    }));
  };

  const isDefaultValues = (): boolean => {
    const { quizId: _qid, ...rest } = quizData;
    const { quizId: _iqid, ...initialRest } = initialQuizData;
    return JSON.stringify(rest) === JSON.stringify(initialRest);
  };

  return {
    quizData,
    quizQuery,
    isDefaultValues,
    updateQuizDraftData,
    removeQuizDraftData,
  };
}
